import { gql, useLazyQuery } from "@apollo/client";

import type { LiveTimeslotType, TimeslotType } from "./types";

const AVAILABILITY_QUERY = gql`
  query Availability($gameId: ID!, $dateGte: Date, $dateLte: Date) {
    availability(gameId: $gameId, dateGte: $dateGte, dateLte: $dateLte) {
      syncedAt
      timeslots {
        id
        available
        datetime
      }
    }
  }
`;

const LIVE_TIMESLOT_QUERY = gql`
  query liveTimeslot($id: ID!) {
    liveTimeslot(id: $id) {
      id
      available
      datetime
      maxPlayers
      minPlayers
      pricingCategories {
        vendorCategoryId
        name
        pricePerPerson
        minQuantity
        maxQuantity
      }
      slotsLeft
    }
  }
`;

interface AvailabilityDataType {
  availability: {
    syncedAt: string | null;
    timeslots: TimeslotType[];
  };
}

interface AvailabilityVariablesType {
  dateGte?: string;
  dateLte?: string;
  gameId: string;
}

interface LiveTimeslotDataType {
  liveTimeslot: LiveTimeslotType;
}

interface LiveTimeslotVariablesType {
  id: string;
}

export function useAvailability() {
  return useLazyQuery<AvailabilityDataType, AvailabilityVariablesType>(
    AVAILABILITY_QUERY
  );
}

export function useLiveTimeslot() {
  return useLazyQuery<LiveTimeslotDataType, LiveTimeslotVariablesType>(
    LIVE_TIMESLOT_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );
}
